export const formatPhoneNumber = (phoneNumber?: string, countryCode?: string): string => {
  if (!phoneNumber) return "N/A";
  if (!countryCode) return phoneNumber;
  const cleanCode = countryCode.toString().trim();
  if (!cleanCode) return phoneNumber;
  const formattedCode = cleanCode.startsWith("+") ? cleanCode : `+${cleanCode}`;
  return `${formattedCode} ${phoneNumber}`;
};
